module.exports = __webpack_public_path__ + "img/repeatgrid2.580cae8d.png";